'use client';

import { useMemo } from 'react';
import { usePathname } from 'next/navigation';
import { useShoppingCart } from '@/context/ShoppingCartContext';
import { extractPageContext } from '../utils/contextExtractor';
import { useAgentNavigation } from './useAgentNavigation';
import type { PageContext } from '../types/agent.types';

export function usePageContext(): PageContext {
  const pathname = usePathname();
  const { cartItems } = useShoppingCart();
  const navigationPages = useAgentNavigation();

  return useMemo(() => {
    const { label: _label, ...context } = extractPageContext(pathname || '/');

    const items = cartItems.map(item => ({
      id: item.id?.toString() || '',
      source: item.cardData?.source || 'Unknown',
      date: item.cardData?.date || item.cardData?.startDate || '',
      price: item.cardData?.price ?? 0,
      resolution: item.cardData?.resolution?.toString() || '',
      type: item.cardData?.sensorType || item.type || '',
    }));

    const totalPrice = items.reduce((sum, i) => sum + i.price, 0);

    context.cart = {
      itemCount: items.length,
      totalPrice,
      items,
    };

    if (navigationPages) context.navigation = { pages: navigationPages };

    return context;
  }, [pathname, cartItems, navigationPages]);
}
